import { render, staticRenderFns } from "./TabGeneralInfo.vue?vue&type=template&id=7802c84d&"
import script from "./TabGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./TabGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./TabGeneralInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports